import { generateUtilityClasses } from '../../utils';

export const pageHeaderSkeletonClasses = generateUtilityClasses('PageHeaderSkeleton', [
  'root',
  'mainContainer',
  'essentials',
  'breadcrumbs',
  'textContainer',
  'title',
  'description',
  'mainAction',
  'extraActions',
  'bottomDivider',
]);
